module.exports = __webpack_public_path__ + "img/top_icon2.96b061d4.png";